
// @ts-nocheck


export const localeCodes =  [
  "da-DK",
  "en-GB",
  "de-DE",
  "lv-LV",
  "sv-SE",
  "pl-PL"
]

export const localeLoaders = {
  "da-DK": [
    {
      key: "locale_da_45DK_46ts_12947afe",
      load: () => import("#nuxt-i18n/12947afe" /* webpackChunkName: "locale_da_45DK_46ts_12947afe" */),
      cache: false
    }
  ],
  "en-GB": [
    {
      key: "locale_en_45GB_46ts_fec740ce",
      load: () => import("#nuxt-i18n/fec740ce" /* webpackChunkName: "locale_en_45GB_46ts_fec740ce" */),
      cache: false
    }
  ],
  "de-DE": [
    {
      key: "locale_de_45DE_46ts_455478c4",
      load: () => import("#nuxt-i18n/455478c4" /* webpackChunkName: "locale_de_45DE_46ts_455478c4" */),
      cache: false
    }
  ],
  "lv-LV": [
    {
      key: "locale_lv_45LV_46ts_e3fe23b5",
      load: () => import("#nuxt-i18n/e3fe23b5" /* webpackChunkName: "locale_lv_45LV_46ts_e3fe23b5" */),
      cache: false
    }
  ],
  "sv-SE": [
    {
      key: "locale_sv_45SE_46ts_d3b9e388",
      load: () => import("#nuxt-i18n/d3b9e388" /* webpackChunkName: "locale_sv_45SE_46ts_d3b9e388" */),
      cache: false
    }
  ],
  "pl-PL": [
    {
      key: "locale_pl_45PL_46ts_44b9d966",
      load: () => import("#nuxt-i18n/44b9d966" /* webpackChunkName: "locale_pl_45PL_46ts_44b9d966" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/8621d1b3" /* webpackChunkName: "config_vueI18n_46config_46ts_8621d1b3" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      name: "Dansk",
      code: "da-DK",
      language: "da-DK",
      dir: "ltr",
      files: [
        {
          path: "/Users/runner/work/1/s/i18n/locales/da-DK.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "English",
      code: "en-GB",
      language: "en-GB",
      dir: "ltr",
      files: [
        {
          path: "/Users/runner/work/1/s/i18n/locales/en-GB.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Deutsch",
      code: "de-DE",
      language: "de-DE",
      dir: "ltr",
      files: [
        {
          path: "/Users/runner/work/1/s/i18n/locales/de-DE.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Latviešu",
      code: "lv-LV",
      language: "lv-LV",
      dir: "ltr",
      files: [
        {
          path: "/Users/runner/work/1/s/i18n/locales/lv-LV.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Svenska",
      code: "sv-SE",
      language: "sv-SE",
      dir: "ltr",
      files: [
        {
          path: "/Users/runner/work/1/s/i18n/locales/sv-SE.ts",
          cache: undefined
        }
      ]
    },
    {
      name: "Polski",
      code: "pl-PL",
      language: "pl-PL",
      dir: "ltr",
      files: [
        {
          path: "/Users/runner/work/1/s/i18n/locales/pl-PL.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "da-DK",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    name: "Dansk",
    code: "da-DK",
    language: "da-DK",
    dir: "ltr",
    files: [
      {
        path: "/Users/runner/work/1/s/i18n/locales/da-DK.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "English",
    code: "en-GB",
    language: "en-GB",
    dir: "ltr",
    files: [
      {
        path: "/Users/runner/work/1/s/i18n/locales/en-GB.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Deutsch",
    code: "de-DE",
    language: "de-DE",
    dir: "ltr",
    files: [
      {
        path: "/Users/runner/work/1/s/i18n/locales/de-DE.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Latviešu",
    code: "lv-LV",
    language: "lv-LV",
    dir: "ltr",
    files: [
      {
        path: "/Users/runner/work/1/s/i18n/locales/lv-LV.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Svenska",
    code: "sv-SE",
    language: "sv-SE",
    dir: "ltr",
    files: [
      {
        path: "/Users/runner/work/1/s/i18n/locales/sv-SE.ts",
        cache: undefined
      }
    ]
  },
  {
    name: "Polski",
    code: "pl-PL",
    language: "pl-PL",
    dir: "ltr",
    files: [
      {
        path: "/Users/runner/work/1/s/i18n/locales/pl-PL.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/